import { useMemo } from "react";
import { Prefill } from "react-calendly/typings/calendly";
import { useUser } from "@hooks/useUser";

interface WidgetCustomAnswers {
    customAnswers?: Prefill["customAnswers"];
}

export function useWidgetOptions({ customAnswers }: WidgetCustomAnswers) {
    const {
        email,
        firstName,
        lastName,
        preferredName,
        legalName,
        unverifiedPhoneNumber,
    } = useUser();

    return useMemo(
        () => ({
            prefill: {
                name: preferredName ?? legalName ?? `${firstName} ${lastName}`,
                email: email ?? "",
                firstName,
                lastName,
                customAnswers: {
                    a2: unverifiedPhoneNumber ?? "",
                    ...(customAnswers ?? {}),
                },
            } satisfies Prefill,
            pageSettings: {
                primaryColor: "#1A78C0",
            },
        }),
        [
            email,
            firstName,
            lastName,
            legalName,
            preferredName,
            customAnswers,
            unverifiedPhoneNumber,
        ],
    );
}
